import React, { Component } from 'react'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'

class DateInput extends Component {
  constructor(props) {
    super(props)
    const date = moment(props.value)
    const startingValue = date.isValid(date) ? date : null

    this.state = {
      currentValue: startingValue,
      focused: false
    }
  }

  handleChange = (date) => {
    const { onChange, property, isOperator } = this.props

    this.setState({
      currentValue: date
    })

    let returnValue
    if (date) {
      returnValue = property.type === 'DATETIME' || isOperator ? date.valueOf() : date.format('YYYY-MM-DD')
    } else returnValue = null

    onChange(returnValue)
  }
  render() {
    const { focused, currentValue } = this.state

    const currentDate = currentValue ? moment(Number(currentValue)) : null;

    return (
        <SingleDatePicker 
          date={currentDate}
          onDateChange={this.handleChange}
          focused={focused}
          placeholder="Select a date…"
          onFocusChange={({ focused }) => this.setState({ focused })}
          id="contact-details--typed_inputs-date"
          screenReaderInputMessage="Set a date for this input field"
          showClearDate={currentValue !== null}
          anchorDirection="left"
          openDirection="down"
          isOutsideRange={() => {}}
          small={true}
          block={true}
          numberOfMonths={1}
          horizontalMargin={10}
          hideKeyboardShortcutsPanel={true}
        />
    )
  }
}

export default DateInput
